if($(".page-content-property-detail").length) {

    let residentialPropertyNameInput = $('#input_2_7');

    if(residentialPropertyNameInput.length) {
        residentialPropertyNameInput.val(window.property_title || '');
    }


    let commercialPropertyNameInput = $('#input_3_7'),
        commercialPropertyBrokerInput = $('#input_3_8');

    if(commercialPropertyNameInput.length) {
        commercialPropertyNameInput.val(window.property_title || '');
    }

    if(commercialPropertyBrokerInput.length) {
        commercialPropertyBrokerInput.val(window.broker_for_contact || '');
    }


    let homePropertyNameInput = $('#input_4_7'),
        homePropertyBrokerInput = $('#input_4_8');

    if(homePropertyNameInput.length) {
        homePropertyNameInput.val(window.property_title || '');
    }

    if(homePropertyBrokerInput.length) {
        homePropertyBrokerInput.val(window.broker_for_contact || '');
    }

}

if($('.wpgmza-checkboxes').length) {
    setTimeout(() => {
        $('.wpgmza-checkboxes').fadeOut();
    }, 100);

    $('.wpgmza-checkboxes li').each(function () {
        let checkbox = $(this).find('input[type=checkbox]');

        checkbox.on('click', function (e) {
            e.stopPropagation();
        });

        $(this).on('click', function () {
            if (checkbox.is(':checked')) {
                checkbox.prop('checked', false);
            } else {
                checkbox.prop('checked', true);
            }
            checkbox.trigger('change');
        });
    });
}

$('.image-modal-toggle').on('click', function (e) {
    let index = $(this).data('image-index');

    setTimeout(() => {
        // scroll to .image-modal-item-
        let item = $('.image-modal-item-' + index);
        if(item.length) {
            item[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
    }, 500);
});

let imagesArrowLeft = $('.images-arrow-left'),
    imageScroller = $('.images-scroller'),
    imagesArrowRight = $('.images-arrow-right');

imagesArrowLeft.on('click', function (e) {
    let scrollLeft = imageScroller.scrollLeft(),
        imageWidth = imageScroller.find('.image-item').outerWidth(true);
    imageScroller.animate({ scrollLeft: scrollLeft + imageWidth }, 500);
});

imagesArrowRight.on('click', function (e) {
    let scrollLeft = imageScroller.scrollLeft(),
        imageWidth = imageScroller.find('.image-item').outerWidth(true);
    imageScroller.animate({ scrollLeft: scrollLeft - imageWidth }, 500);
});

imageScroller.on('scroll', function () {
    let scrollLeft = imageScroller.scrollLeft();

    if (scrollLeft > 0) {
        imageScroller.parent().addClass('has-been-scrolled');
    } else {
        imageScroller.parent().removeClass('has-been-scrolled');
    }
});

if($("#gf_7").length) {
    let brokerEmail = $('#commercial-broker-email').val();
    if(brokerEmail && $('#input_7_16').length) $('#input_7_16').val(brokerEmail);
}

if($("#gf_9").length) {
    let propertyName = $('#property-name').val();
    if(propertyName && $('#input_9_10').length) $('#input_9_10').val(propertyName);

    let brokerEmail = $('#broker_email').val();
    if(brokerEmail && $('#input_9_11').length) $('#input_9_11').val(brokerEmail);
}
